import { FBPage } from 'components/FbUI/Page/FBPage'
import {
  CompanySidebar,
  CompanySidebarHeader,
  SidebarTabConfig,
} from './Sidebar'
import * as S from '../Cards/Cards.styles'
import { RouterLink } from 'components/UI/Anchor'

// Export CompanyContentSections for use in company pages
export { CompanyContentSections } from './CompanyContentSections'

interface CompanyPageLayoutProps {
  breadcrumbRoot: string
  breadcrumbs?: { breadcrumb: string; title?: string; url?: string }[]
  chainProxyId: number
  sidebar: {
    header: CompanySidebarHeader
    tabs: SidebarTabConfig[]
  }
  doorId?: number
  address?: string
  phone?: string
  children?: React.ReactNode
}

export function CompanyPageLayout(props: CompanyPageLayoutProps) {
  const { chainProxyId } = props

  return (
    <FBPage className="gap-y-4" noContainer>
      {/* Breadcrumbs using existing components */}
      <div className="flex items-center self-stretch px-20 pb-6 pt-2">
        <S.BreadcrumbGroup>
          <S.BreadcrumbBadge pill>{props.breadcrumbRoot}</S.BreadcrumbBadge>
          {props.breadcrumbs?.map((breadcrumb, i) => {
            return (
              <S.BreadcrumbContainer key={i}>
                <S.RChevronIcon />
                <div>
                  {breadcrumb.title && (
                    <S.BreadcrumbTitle>{breadcrumb.title}: </S.BreadcrumbTitle>
                  )}
                  {breadcrumb?.url ? (
                    <RouterLink to={breadcrumb.url} target="_blank">
                      {breadcrumb.breadcrumb}
                    </RouterLink>
                  ) : (
                    <span>{breadcrumb.breadcrumb}</span>
                  )}
                </div>
              </S.BreadcrumbContainer>
            )
          })}
        </S.BreadcrumbGroup>
      </div>

      {/* Content area with padding matching Figma design */}
      <div className="flex justify-end gap-6 px-20 pb-0">
        <CompanySidebar
          chainProxyId={chainProxyId}
          {...props.sidebar}
          doorId={props.doorId}
          address={props.address}
          phone={props.phone}
        />

        <div className="flex-1 min-w-0 flex flex-col gap-6">
          {/* Main content sections */}
          {props.children || (
            <>
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5">
                {/* Content section 1 - empty for now */}
              </div>
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5">
                {/* Content section 2 - empty for now */}
              </div>
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5">
                {/* Content section 3 - empty for now */}
              </div>
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5">
                {/* Content section 4 - empty for now */}
              </div>
            </>
          )}
        </div>
      </div>
    </FBPage>
  )
}
